/*
 * @Descripttion: 人群营销短信效果数据页
 * @Author: yang chenglin
 * @LastEditors: yang chenglin
 */
import React, {useEffect, useState, createContext, Context} from 'react';
import { Dialog, Loading } from '@alifd/next';
import moment from 'moment'
import LzMsg from '@/components/common/LzMsg';
import utils from '../../common/utils';
import BaseInfo from './components/BaseInfo';
import RoiInfo from './components/RoiInfo';
import TimeInfo from './components/TimeInfo';
import DataInfo from './components/DataInfo';
import ChangePrice from './components/ChangePrice';
import { Servlets } from '@/service';
import styles from './index.module.scss';

export const ActivityContext: Context<any> = createContext({});
const EffectData = (props) => {
  const [pageLoading, setPageLoading] = useState(true);
  const [taskInstId, setTaskId] = useState(props.match.params.taskInstId);
  useEffect(() => {
    /** 设置Header面包屑 */
    // 20250827 不再展示三级面包屑
    utils.setBreadcrumb({
      name: '效果数据', // 一级页面名称
      url: '', // 一级页面url
      // children: {
      //   name: '人群营销', // 二级页面名称
      //   url: '/web/crowdMarketing', // 二级页面url
      //   children: {
      //     name: '效果数据', // 三级页面名称
      //     url: `/web/crowdMarketing/marketingEffect/task/${props.match.params.taskInstId}`, // 三级页面url
      //   },
      // },
    });
  }, []);

  const [taskInfo, setTaskInfo] = useState({
    name: '',
    lastUpdateTime: '',
    type: '',
    smsContent: '',
    sendTime:'',
  });

  const [ratioTime, setRatioTime] = useState(1);
  const [roiInfo, setRoiInfo] = useState({
    cost: '',
    earnings: '',
    roi: '',
    actualNum: ''
  });

  const [updateTime, setUpdateTime] = useState('');

  const [panelInfo, setPanelInfo] = useState({
    prepNum: '',
    actualNum: '',
    recallUserCnt: '',
    sendRate: '',
    recallUserCntRate: '',
    recallOrderUserCntRate: '',
    prepSmsNum: '',
    actualSmsNum: '',
    orderUserCnt: '',
    orderAmt: '',
    perOrderUserAmt: '',
    orderUserCntRate: '',
    roi: '',
  });

  const [changePriceDialog, setChangePriceDialog] = useState(false);

  // 调接口查数据
  const getData = async (day = 1) => {
    Servlets('getEffectData', {
      day,
      taskInstId
    }).then((res) => {
      if (res.success) {
        setTaskInfo({
          ...taskInfo,
          name: res.data.name,
          lastUpdateTime: res.data.lastUpdateTime,
          type: res.data.type,
          smsContent: res.data.smsContent,
          sendTime:res.data.sendTime
        });

        setRoiInfo({
          ...roiInfo,
          cost: res.data.cost,
          earnings: res.data.earnings,
          roi: res.data.roi,
          actualNum: res.data.actualNum
        })

        setUpdateTime(moment(res.data.updateTime).format('YYYY-MM-DD HH:mm:ss')?? '');

        setPanelInfo({
          ...panelInfo,
          prepNum: res.data.prepNum,
          actualNum: res.data.actualNum,
          recallUserCnt: res.data.recallUserCnt,
          sendRate: res.data.sendRate,
          recallUserCntRate: res.data.recallUserCntRate,
          recallOrderUserCntRate: res.data.recallOrderUserCntRate,
          prepSmsNum: res.data.prepSmsNum,
          actualSmsNum: res.data.actualSmsNum,
          orderUserCnt: res.data.orderUserCnt,
          orderAmt: res.data.orderAmt,
          perOrderUserAmt: res.data.perOrderUserAmt,
          orderUserCntRate: res.data.orderUserCntRate,
          roi: res.data.roi,
        })
        setPageLoading(false);
      } else {
        LzMsg.error(res.resp_msg);
        setPageLoading(false);
      }
    });
  };

  // 切换面板的筛选时间
  const changeROITime = async (value) => {
    setRatioTime(value);
    await getData(value);
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <ActivityContext.Provider
      value={{
        taskInstId,
        taskInfo,
        ratioTime,
        changeROITime,
        roiInfo,
        updateTime,
        panelInfo,
        setChangePriceDialog
      }}
    >

    <section className={styles['market-effect-section']}>
      <div style={{width: 350}}>
        <div style={{width: 350}}>
          <div className={styles['market-effect-section-title']}>任务总览</div>
          <div>
            <BaseInfo />
          </div>
        </div>

        <div style={{width: 350, marginTop: 20}}>
          <div className={styles['market-effect-section-title']}>ROI（投入产出比）</div>
          <div>
            <RoiInfo />
          </div>
        </div>
      </div>

      <div style={{marginLeft: 30, flexGrow: 1}}>
        <div>
          <div className={styles['market-effect-section-title']}>数据详情</div>
          <div>
            <TimeInfo />
          </div>
        </div>
        {/* <div>
          <div className={styles['market-effect-section-title']}>梯形图</div> */}
          <div style={{marginTop: 20}}>
            <DataInfo />
          </div>
        {/* </div> */}
      </div>

      <Dialog
        title="修改短信单价"
        footer={false}
        isFullScreen
        visible={changePriceDialog}
        onClose={() => setChangePriceDialog(false)}
        shouldUpdatePosition
        style={{ width: 520 }}
      >
        <ChangePrice />
      </Dialog>
    </section>
    <Loading visible={pageLoading} />
    </ActivityContext.Provider>
  );
};

export default EffectData;
